import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["resendsSection", "groups", "offDuty"];

  connect() {
    this.updateVisibility();
  }

  seedRow({ detail: { row } }) {
    this.seedGroups(row);
    this.seedOffDuty(row);
  }

  updateVisibility() {
    if (!this.hasResendsSectionTarget) return;

    const hiddenInput = this.element.querySelector('input[type="hidden"][name*="[poll_id]"]');
    const selectInput = this.element.querySelector('select[name*="[poll_id]"]');
    const source = hiddenInput || selectInput;
    if (!source) return;

    const pollValue = source.value;
    const hasPoll = pollValue && pollValue !== "" && pollValue !== "none" && pollValue !== "0";
    this.resendsSectionTarget.classList.toggle("no-show", !hasPoll);
  }

  // The row's own fields are found by their data-resend-field marker, not by
  // the groups/offDuty targets: those targets mark only the action's own
  // fields (the seed source), so a resend row carries no
  // notification-resends target at all.
  seedGroups(row) {
    if (!this.hasGroupsTarget) return;

    const select = row.querySelector('[data-resend-field="groups"]');
    if (!select) return;

    const values = Array.from(this.groupsTarget.selectedOptions).map((option) => option.value);
    Array.from(select.options).forEach((option) => {
      option.selected = values.includes(option.value);
    });
  }

  seedOffDuty(row) {
    if (!this.hasOffDutyTarget) return;

    const checkbox = row.querySelector('[data-resend-field="off_duty"]');
    if (checkbox) checkbox.checked = this.offDutyTarget.checked;
  }
}
